"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
require("font-awesome/css/font-awesome.min.css");
var react_portal_tooltip_1 = require("react-portal-tooltip");
var styled_components_1 = require("styled-components");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding:3px\n"], ["\n    padding:3px\n"])));
var ToolTipComp = function (props) {
    var _a = react_1.useState(false), isTooltipActive = _a[0], setTooltipActive = _a[1];
    var showTooltip = function () {
        setTooltipActive(true);
    };
    var hideTooltip = function () {
        setTooltipActive(false);
    };
    return (React.createElement("div", { style: { marginTop: '30px' } },
        React.createElement("p", { id: "text", onFocusCapture: showTooltip, onKeyPress: showTooltip, onBlurCapture: hideTooltip }, props.component),
        React.createElement(react_portal_tooltip_1.default, { active: isTooltipActive, position: "top", arrow: "center", parent: "#text" },
            React.createElement(Container, null,
                props.max8digit,
                props.upperCase,
                props.lowerCase,
                props.digits,
                props.specialSymbol))));
};
exports.default = ToolTipComp;
var templateObject_1;
//# sourceMappingURL=ToolTipComp.js.map